import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PdfGenerateComponent } from '../dialogs/pdf-generate/pdf-generate.component';
import { PDFInterface } from '@contracts/interfaces/pdf.interface';
import { ConnectionService } from './connection.service';
import { PDFDialogComponent } from '../dialogs/pdf-dialog/pdf.dialog';

@Injectable({
  providedIn: 'root'
})
export class PDFService {

    constructor(private http: HttpClient,
        private connectionService: ConnectionService,
        public dialog: MatDialog,
        public router: Router) {}


    openPDFDialog(PDFTemplate: string, data: any, callback?: any) {
        let dialog = this.dialog.open(PDFDialogComponent, {
            width: '1000px',
            height: '100vh',
            maxHeight: '100%',
            autoFocus: false,
            data: {
                PDFTemplate,
                data
            }
        });

        dialog.afterClosed().subscribe(r => {
            if (callback != undefined) {
                callback();
            }
        });
    }

    generatePDF(template: any) {
        return this.http.post(this.connectionService.address + "/pdf-service/generate", {template});
    }

    generatePDF2(PDFTemplate: string, data: any) {
        return this.http.post(this.connectionService.address + "/pdf-service/generate", { PDFTemplate, data });
    }

    check(PDFTemplate: string, data) {
        return this.http.post(this.connectionService.address + "/pdf-service/check", { PDFTemplate, data });
    }

    download(PDFTemplate: string, data: any, filename: string, callback: any = {}) {
       
        this.check(PDFTemplate, data).subscribe((result: any)=> {

            if (result.hash == null) {
                let dialog = this.dialog.open(PdfGenerateComponent, {
                    width: '400px',
                    autoFocus: false,
                    data: {
                        PDFTemplate,
                        data
                    }
                });
        
                dialog.afterClosed().subscribe(r => {
                    if (callback != undefined) {
                        callback();
                    }
                });

                this.generatePDF2(PDFTemplate, data).subscribe((result:any) => {
                    let address = this.connectionService.address + "/pdf-service/view?file="+result.hash+"&filename=" + filename;
                    window.location.replace(address);
                    dialog.close("generated");
                });
            } else {
                let address = this.connectionService.address + "/pdf-service/view?file="+result.hash+"&filename=" + filename;
                window.location.replace(address);
            }
        })
    }

    print (PDFTemplate: string, data: any, callback: any = {}) {
        this.check(PDFTemplate, data).subscribe((result: any)=> {

            if (result.hash == null) {
                let dialog = this.dialog.open(PdfGenerateComponent, {
                    width: '400px',
                    autoFocus: false,
                    data: {
                        PDFTemplate,
                        data
                    }
                });
        
                dialog.afterClosed().subscribe(r => {
                    callback();
                });

                this.generatePDF2(PDFTemplate, data).subscribe((result:any) => {
                    let address = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html#print";
                    window.open(address, "_blank");
                    dialog.close("generated");
                });
            } else {
                let address = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html#print";
                window.open(address, "_blank");
            }
        })
    }

    view(PDFTemplate: string, data: any, callback: any = {}) {
        this.check(PDFTemplate, data).subscribe((result: any)=> {

            if (result.hash == null) {
                let dialog = this.dialog.open(PdfGenerateComponent, {
                    width: '400px',
                    autoFocus: false,
                    data: {
                        PDFTemplate,
                        data
                    }
                });
        
                dialog.afterClosed().subscribe(r => {
                    callback();
                });

                this.generatePDF2(PDFTemplate, data).subscribe((result:any) => {
                    let address = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html";
                    window.open(address, "_blank");
                    dialog.close("generated");
                });
            } else {
                let address = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html";
                window.open(address, "_blank");
            }
        })
    }

    url(PDFTemplate: string, data: any, callback: any, showLoadingDialog: boolean = true) {
        this.check(PDFTemplate, data).subscribe((result: any)=> {

            if (result.hash == null) {
                let dialog;
                if (showLoadingDialog) {
                    dialog = this.dialog.open(PdfGenerateComponent, {
                        width: '200px',
                        data: {
                            PDFTemplate,
                            data
                        }
                    });
                    
                    dialog.disableClose = true;
            
                    dialog.afterClosed().subscribe(r => {
                        callback(r);
                    });
                }

                this.generatePDF2(PDFTemplate, data).subscribe((result:any) => {
                    if (showLoadingDialog) {
                        dialog.close(this.connectionService.address + "/pdf-service/view?file="+result.hash);
                    } else {
                        callback(this.connectionService.address + "/pdf-service/view?file="+result.hash);
                    }
                });
            } else {
                callback(this.connectionService.address + "/pdf-service/view?file="+result.hash);
            }
        });
    }

    private resolve (hash: string) {
        let address = this.connectionService.address + "/pdf-service/view?file="+hash+"&filename=test";
        
        window.location.replace(address);
    }

}
